<template>
  <div>
    <v-data-table
      :headers="headersTotalUser"
      :items="$store.state.homes.userTotalByChips"
      :sort-by="['chipAmount']"
      :sort-desc="[true]"
      :items-per-page="10000"
      hide-default-footer
      style="max-width:1000px; margin: auto;"
      class="elevation-1"
    >
      <template v-slot:item.userName="{ item }">
        <user-detail-card
          :userId="item.id"
          :pictureUrl="item.pictureUrl"
          :userName="item.userName"
          :level="item.level"
          :flag="item.flag"
          :isOnline="item.playerOnline.o"
        />
      </template>

      <template v-slot:item.vipInfo.currentPoint="{ item }">
        <div>
          {{ item.vipInfo.currentPoint | formatMoney }}
        </div>
      </template>
      <template v-slot:item.vipInfo.vipLevel="{ item }">
        {{ item.vipInfo.vipLevel | formatMoney }}
      </template>
      <template v-slot:item.chip="{ item }">
        <div>
          {{ item.chip | formatMoney }}
        </div>
      </template>
      <template v-slot:item.playerOnline.lastOnline="{ item }">
        <div v-if="!item.playerOnline.isOnline">
          <timeago
            :style="
              ` color: ${item.leftTime < 86400 * 3.1 ? 'orange' : '#ff7e7e'}`
            "
            locale="zh_TW"
            :datetime="new Date(item.playerOnline.lastOnline * 1000)"
          ></timeago>
        </div>
      </template>
      <template v-slot:item.playerOnline.isOnline="{ item }">
        <div
          :style="
            ` height: 10px;  width: 10px; border-radius:10px;background: ${
              item.playerOnline.isOnline ? 'lime' : '#ff7e7e'
            }`
          "
        ></div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import UserDetailCard from "../../components/Users/UserDetailCard.vue";

export default {
  components: { UserDetailCard },
  data() {
    return {
      headersTotalUser: [
        { text: "UserName", value: "userName" },
        { text: "Chip", value: "chip" },
        { text: "Gems", value: "gemsAmount" },
        { text: "Level", value: "level" },
        { text: "Vip CurrentPoint", value: "vipInfo.currentPoint" },
        { text: "Is Online", value: "playerOnline.isOnline" },
        { text: "Last Online", value: "playerOnline.lastOnline" },
      ],
    };
  },
  async mounted() {
    this.$store.dispatch("homes/getUserTotalByChip");
  },
};
</script>
